/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import PropTypes from 'prop-types';

import { Centered, ErrorMessage } from './ExportPanelError.styled';

import Button from '$components/Button';

const ExportPanelError = ({ onTryAgain }) => (
  <Centered>
    <ErrorMessage>
      There was a problem loading the grades. Check your internet connection and
      try again.
    </ErrorMessage>
    <Button look="purple" size="large" onClick={onTryAgain} label="Try again">
      Try again
    </Button>
  </Centered>
);

ExportPanelError.propTypes = {
  onTryAgain: PropTypes.func.isRequired,
};

export default ExportPanelError;
